import { Dimensions, Platform, PixelRatio, NativeModules } from 'react-native';
import { getCookie } from './cookie';
import yoda from '@kibt/bridge';
import { versionCompare } from '@kibt/web-utils/version';
import { useEffect, useState } from 'react';
import { getQuery } from './const';
import { setCookie } from '@kwr/utils-krn';

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window?.opera;
    // 检查User-Agent字符串中是否包含移动设备的关键词
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};

const platform = (function getSys() {
    const ua = navigator?.userAgent;
    const rules = [
        [/\(iPad;/, 'ipad'],
        [/\(iPhone;/, 'iphone'],
        [/ Android /, 'android'],
        [/ Mac OS X /, 'mac'],
        [/ Windows /, 'windows'],
    ];
    for (let i = 0; i < rules.length; i++) {
        const tmp = rules[i];
        const rule = tmp[0] as RegExp;
        const name = tmp[1];
        const rRes = ua && rule.exec(ua);
        if (rRes) {
            return name;
        }
    }
    return '';
})();

export const isAndroidKDS: boolean = Platform.OS === 'android';
export const isAndroid: boolean = isAndroidKDS || platform === 'android';
export const isIOSKDS: boolean = Platform.OS === 'ios';
export const isIOS: boolean = isIOSKDS || platform === 'iphone' || platform === 'ipad';
export const appVersion = (getCookie('appver') as string) || '0.0.0';
export const isWeb = Platform.OS === 'web';

const KPF_OUTSIDE_CONST = {
    pc: 'PC_WEB',
    android_h5: 'OUTSIDE_ANDROID_H5',
    ios_h5: 'OUTSIDE_IOS_H5',
};

const PKG = getCookie('pkg');
export const kpn = (() => {
    if (isIOS) {
        return KPF_OUTSIDE_CONST.ios_h5;
    }
    if (isAndroid) {
        return KPF_OUTSIDE_CONST.android_h5;
    }
    return KPF_OUTSIDE_CONST.pc;
})();
export const originDPR = PixelRatio.get();
export const DPR = originDPR && !isNaN(originDPR) ? Math.ceil(originDPR * 10) / 10 : 2;
export const isKwai = kpn === 'KWAI';
export const isKwaiMe = kpn === 'KWAI.ME';
export const isSnack = kpn === 'KWAI_BULLDOG';
export const isInApp = !(Platform.OS === 'web' && window.navigator.userAgent.indexOf('Kwai') === -1);
export const IS_KWAI_LITE = PKG === 'kwai.lite.video';
console.log('appVersion:::', appVersion, versionCompare(appVersion, '9.8.40'));
// 浏览器容器的高度
export const { width: windowWidth, height: windowHeight } = Dimensions.get('window');
// 屏幕的高度
export const { width: screenWidth, height: screenHeight } = Dimensions.get('screen');
console.log('windowWidth', windowWidth, 'windowHeight', windowHeight, 'screenWidth', screenWidth, 'screenHeight', screenHeight);
export const useRealSize = () => {
    // 有时候通过Dimensions.get('window')来获取大小会返回0，如果是0，可能导致前端页面中的样式高度为0而无法展示
    const [_windowWidth, setWindowWidth] = useState(0);
    const [_windowHeight, setWindowHeight] = useState(0);
    const [_screenWidth, setScreenWidth] = useState(0);
    const [_screenHeight, setScreenHeight] = useState(0);
    useEffect(() => {
        // 如果这四个值存在为0的情况
        let count = 0;
        if (!(windowWidth && windowHeight && screenHeight && screenWidth)) {
            const interval = setInterval(() => {
                count++;
                const { width: newScreenWidth, height: newScreenHeight } = Dimensions.get('screen');
                const { width: newWindowWidth, height: newWindowHeight } = Dimensions.get('window');
                console.log(
                    'useReactiveSize',
                    newWindowWidth,
                    newWindowHeight,
                    newScreenWidth,
                    newScreenHeight,
                    count,
                    newWindowWidth && newWindowHeight && newScreenWidth && newScreenHeight
                );
                if (newWindowWidth && newWindowHeight && newScreenWidth && newScreenHeight) {
                    setWindowWidth(newWindowWidth);
                    setWindowHeight(newWindowHeight);
                    setScreenHeight(newScreenHeight);
                    setScreenWidth(newScreenWidth);
                    clearInterval(interval);
                }
                if (count === 5) {
                    setWindowWidth(newWindowWidth || 760);
                    setWindowHeight(newWindowHeight || 760);
                    setScreenHeight(newScreenHeight || 760);
                    setScreenWidth(newScreenWidth || 760);
                    clearInterval(interval);
                }
            }, 100);
        } else {
            setWindowWidth(windowWidth);
            setWindowHeight(windowHeight);
            setScreenHeight(screenHeight);
            setScreenWidth(screenWidth);
        }
    }, []);
    return {
        windowWidth: _windowWidth,
        windowHeight: _windowHeight,
        screenHeight: _screenHeight,
        screenWidth: _screenWidth,
    };
};

// 如果比例<0.95说明是半屏容器场景
/**
 * @deprecated 暂时不可用，需要客户端支持
 */
export const isHalf = windowHeight / screenHeight < 0.94;

export const getHalfByQuery = () => windowHeight / screenHeight < 0.94 || getQuery('webviewType') === 'half' || +getQuery('isHalf') === 1;
console.log('isHalf: ', isHalf, 'Dimensions: ', windowHeight, screenHeight, windowHeight / screenHeight);

// 通过桥来判断 是否是半屏
export const isHalfByBridgeAsync = async () => {
    // 记录：2023/9/15 修复
    // ios从半屏跳转到全屏再返回到半屏后，此处的isHalf会变成0，不符合预期，fixed按钮异常
    // 9830已修复
    let isHalfRes: boolean;
    try {
        // 业务兼容，低于9.5.40版本不调用，否则会有错误toast
        const versionSupport = versionCompare(appVersion, '9.5.40');
        if (versionSupport < 0) {
            console.log('客户端版本不支持');
            throw new Error('客户端版本不支持');
        }
        const res = await yoda.component.isHalfContainerStatus({});
        console.log('支持 isHalfContainerStatus', res);
        isHalfRes = res?.isHalf === 1;
    } catch (error) {
        console.log('不支持 isHalfContainerStatus', isHalf);
        // 如果桥挂了 就降级到上述办法
        isHalfRes = isHalf;
    }
    return isHalfRes;
};

export type NetworkTypeEnum = 'WIFI' | 'MOBILE_2G' | 'MOBILE_3G' | 'MOBILE_4G' | 'MOBILE' | 'DISALBE';

export const getNetworkType = async () => {
    if (isAndroid) return NativeModules.KRNBasic?.getNetworkType?.() as NetworkTypeEnum;
    if (isIOS && versionCompare(appVersion, '10.7.20') === 1) {
        return await (yoda?.kwaiInvoke ?? yoda?.invoke)('system.getNetworkType').then(res => {
            // res = {"net": "WIFI"}
            const net = res?.net || 'UNKNOWN';
            return net;
        });
    }
};
export const isMobileDeviceValue = isMobileDevice();
export const PCMaxWidthRemValue = (() => {
    const baseFontSize = 414 / 100;
    // 进行 px 到 rem 的转换
    const pxNumber = 414;
    const remValue = pxNumber / baseFontSize;
    return remValue;
})();
export const PCMaxWidth = `${PCMaxWidthRemValue}rem`;

export const AdjustPCStyle = {
    width: isMobileDeviceValue ? '100%' : PCMaxWidth,
    marginLeft: isMobileDeviceValue ? 0 : `calc(50% - ${PCMaxWidthRemValue / 2}rem)`,
};
export const isSmallDeviceWidth = windowWidth < 414;
console.log('isSmallDeviceWidth =>', isSmallDeviceWidth);

export const setSameDomainCookie = (key: string, value: string) => {
    const pathName = window.location.origin.split('.').splice(-2, 2).join('.');
    setCookie(key, value, {
        domain: `.${pathName}`,
        path: '/',
        secure: false,
        sameSite: 'lax',
        exdays: 365,
    });
};
